import React, { useState, useEffect } from 'react';
import { FaArrowUpFromBracket } from "react-icons/fa6";

const ScrollToTop = ({ styleClass = "scrollToTop--style1" }) => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Smooth scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <a 
          href="#" 
          className={`scrollToTop ${styleClass}`} 
          onClick={(e) => {
            e.preventDefault();
            scrollToTop();
          }}
          aria-label="Scroll to top"
        >
          <FaArrowUpFromBracket />
        </a>
      )}
    </>
  );
};

export default ScrollToTop;